
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.333 2.667a.667.667 0 00-.666.667v9.333c0 .369.298.667.666.667h9.334a.667.667 0 00.666-.667V3.334a.667.667 0 00-.666-.667H3.333zm-2 .667a2 2 0 012-2h9.334a2 2 0 012 2v9.333a2 2 0 01-2 2H3.333a2 2 0 01-2-2V3.334z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 4.667c.368 0 .667.299.667.667v5.333a.667.667 0 11-1.334 0V5.334c0-.368.299-.667.667-.667z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.667 8c0-.368.298-.666.666-.666h5.334a.667.667 0 110 1.333H5.333a.667.667 0 01-.666-.666z"}})])
          )
        }
      }
    